import { render, staticRenderFns } from "./Item2ColLinkEl.vue?vue&type=template&id=8089e9be&scoped=true&"
import script from "./Item2ColLinkEl.vue?vue&type=script&lang=ts&"
export * from "./Item2ColLinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./Item2ColLinkEl.vue?vue&type=style&index=0&id=8089e9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8089e9be",
  null
  
)

export default component.exports